module.exports = __webpack_public_path__ + "img/Sindo News.7ae25011.png";